import * as React from "react";
const SvgFiRrHandshakeSimpleSlash = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-handshake-simple-slash_svg__a)">
      <path
        fill="#062147"
        d="M22.372 16h.666a1 1 0 1 0 0-2h-.666a5 5 0 0 0-.874.084l-6.096-6.096.868-.83a1 1 0 1 0-1.383-1.446l-3.965 3.795-1.414-1.414 4.55-4.283a3.03 3.03 0 0 1 3.374-.496l2.314 1.157c.69.346 1.464.528 2.236.528h1.056a1 1 0 1 0 0-2h-1.056c-.464 0-.927-.109-1.34-.317l-2.317-1.158c-1.83-.913-4.152-.57-5.639.83l-.618.581-.7-.638A5 5 0 0 0 7.978 1c-.769 0-1.538.182-2.228.525l-1.874.937L1.707.293A.999.999 0 1 0 .293 1.707l22 22a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414l-4.597-4.597 1.461-1.096a3.02 3.02 0 0 1 1.801-.6M6.645 3.314c1.03-.513 2.46-.374 3.377.462l.586.534-2.515 2.368-2.725-2.725zm11.037 12.953-5.346-5.346 1.621-1.55 5.547 5.546-1.82 1.35zm-2.51 3.133a1 1 0 0 1-.2 1.4l-.492.368a3.96 3.96 0 0 1-2.437.833 4 4 0 0 1-2.46-.844L3.506 16.6a3.02 3.02 0 0 0-1.8-.6h-.668a1 1 0 1 1 0-2h.667c1.075 0 2.141.355 3 1l6.091 4.57a2.005 2.005 0 0 0 2.47.01l.506-.38a.997.997 0 0 1 1.4.201"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-handshake-simple-slash_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHandshakeSimpleSlash;
